import { all, fork } from "redux-saga/effects";

//public
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import LayoutSaga from "./layout/saga";
import ecommerceSaga from "./e-commerce/saga";
import calendarSaga from "./calendar/saga";
import chatSaga from "./chat/saga";
import cryptoSaga from "./crypto/saga";
import invoiceSaga from "./invoices/saga";
import OfferSaga from "./offer/saga";
import JobsBookmark from "./jobs_bookmark/saga";
import JobsFriend from "./jobs_friend/saga";
import JobsApply from "./jobs_apply/saga";
import JobsView from "./jobs_view/saga";
import projectsSaga from "./projects/saga";
import tasksSaga from "./tasks/saga";
import mailsSaga from "./mails/saga";
import contactsSaga from "./contacts/saga";
import dashboardSaga from "./dashboard/saga";
import AllProfil from "./Profil/saga"
import dashboardSaasSaga from "./dashboard-saas/saga";
import dashboardCryptoSaga from "./dashboard-crypto/saga";
import dashboardBlogSaga from "./dashboard-blog/saga";
import dashboardJobSaga from "./dashboard-jobs/saga";
import AllPartnerProfile from "./PartnerProfil/saga"
import TeamLeader from "./teamleader/saga"

import JobsTeam from "./team/saga";
import Schedule_Saga from "./schedule/saga";
import Inform_Saga from "./inform/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(LayoutSaga),
    fork(ecommerceSaga),
    fork(calendarSaga),
    fork(chatSaga),
    fork(mailsSaga),
    fork(cryptoSaga),
    fork(invoiceSaga),
    fork(JobsView),
    fork(OfferSaga),
    fork(JobsBookmark),
    fork(JobsApply),
    fork(JobsFriend),
    fork(projectsSaga),
    fork(tasksSaga),
    fork(contactsSaga),
    fork(dashboardSaga),
    fork(AllProfil),
    fork(dashboardSaasSaga),
    fork(dashboardCryptoSaga),
    fork(dashboardBlogSaga),
    fork(dashboardJobSaga),
    fork(AllPartnerProfile),
    fork(TeamLeader),
    fork(JobsTeam),
    fork(Schedule_Saga),
    fork(Inform_Saga),
  ]);
}
